import { useEffect, useState } from "react";

function ThingsToDo() {
  const [thingsToDo, setThingsToDo] = useState(null);

  useEffect(() => {
    fetch('/things-to-do.json')
      .then((res) => res.json())
      .then((data) => setThingsToDo(data))
      .catch((err) => console.error("Failed to load things to do:", err));
  }, []);

  if (!thingsToDo) return null;

  return (
    <div className="container">
      <h1 className="tangerine-bold">Things to do</h1>
      <p className="josefin-slab">
        For those travelling from outside of town, here are some things we love to do in Halifax and the surrounding area if you're planning to make a weekend of it.
      </p>

      {thingsToDo.sections.map(({ title, places }) => (
        <div className="content" key={title}>
          <h2 className="josefin-slab upper">{title}</h2>

          <div className="places-to-visit">
            {places.map(({ imagePath, imageAlt, description, descriptionClass, signature, name, url }) => (
              <div className="postcard" key={name}>
                <div className="postcard-inner">
                  <div className="postcard-front">
                    <img src={imagePath} alt={imageAlt} />
                  </div>
                  <div className="postcard-back">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <p className={descriptionClass}>{description}</p>
                            <p className="tangerine-regular" style={{ fontSize: '1em' }}>{signature}</p>
                          </td>
                          <td>
                            <h3>{name}</h3>
                            <p>
                              <a href={url} target="_blank" rel="noopener noreferrer">Find out more</a>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ThingsToDo;
